 const proto = `syntax = "proto2";
package pic_resize_data;

message PicResizeUrlParam {
    optional int32 resize_width = 1;
    optional int32 resize_height = 2;
    message PicInfo {
        optional string pic_url = 1;
    }
    repeated PicInfo pic_info = 3;
    optional int32 template_style = 4;
}

message TemplateInfo {
    repeated PicResizeInfo list = 1;
}

message PicResizeInfo {
    optional int32 template_style_id = 1;
    optional int32 resize_width = 2;
    optional int32 resize_height = 3;
    optional string resize_pic_size = 4;
    optional int32 resize_pic_num = 5;
    optional int32 status = 6;
    optional int32 modify_time = 7;
    map<int32, TemplateConfigList> template_config = 8;
}
message TemplateConfigList {
    repeated TemplateConfig config = 1;
}

message TemplateConfig {
    optional int32 layout = 1;
    optional TemplateConfigText text = 2;
    optional TemplateConfigPic picture = 3;
    optional int32 required = 4;
}

message TemplateConfigText {
    optional int32 max_length = 1;
    optional int32 min_length = 2;
}

message TemplateConfigPic {
    optional int32 width = 1;
    optional int32 height = 2;
}

message DynamicTemplate {
    optional int32 resize_width = 1;
    optional int32 resize_height = 2;
    message Native {
        message Image {
            //图片url
            optional string url = 1;
            optional int32 width = 2;
            optional int32 height = 3;
        }

        message Text {
            //文字
            optional string text = 1;
        }
        message Video {
            optional string url = 1;
            optional int32 width = 2;
            optional int32 height = 3;
            optional int32 max_duration = 4;
            optional int32 min_duration = 5;

        }

        enum NativeType {
            NATIVE_TITLE = 1;
            NATIVE_IMAGE = 2;
            NATIVE_ICON = 3;
            NATIVE_SUBTITLE = 4;
            NATIVE_DESCRIPTION = 5;
            NATIVE_BUTTON_TEXT = 6;
            NATIVE_VIDEO = 7;
            NATIVE_LOGO = 8;
            NATIVE_ADVERTISER = 9;

        }

        message Item {
            required NativeType type = 1;
            optional string id = 2;
            //图片
            optional Image image = 3;
            //标题
            optional Text text = 4;
            //视频
            optional Video video = 5;
        }
        repeated Item item = 1;
    }

    optional Native native = 3;
    optional int32 template_style = 4;
    optional int32 idx = 5;
    optional int32 template_version = 6;
}
`;
export  default proto